<template>
    <v-app>
        <v-snackbar
                v-model="snackbar"
                top=true
                color="red"
                timeout=4000
        >
            {{ errorMsg }}
            <v-btn
                    color="white"
                    icon
                    @click="snackbar = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-card width="400px" class="mt-12 mx-auto">
            <v-card-title class="pb-5">
                <h1>Connexion</h1>
            </v-card-title>
            <v-form @submit.prevent="dologin">
                <v-card-text>
                    <v-text-field
                            label="Utilisateur"
                            prepend-icon="mdi-account-circle"
                            v-model="username"
                    />
                    <v-text-field
                            label="Mot de Passe"
                            :type="showPassword ? 'text' : 'password'"
                            prepend-icon="mdi-lock"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showPassword = !showPassword"
                            v-model="password"
                    />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-flex justify-center>
                        <v-btn
                                color="success"
                                type="submit"
                        >
                            Se connecter
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-app>
</template>

<script>

    import { authComputed } from '@/store/helpers.js'

    export default {
        name: 'Login',
        data() {
            return {
                showPassword: false,
                snackbar: false,
                errorMsg: '',
                username: '',
                password: ''
            }
        },
        computed: {
            ...authComputed
        },
        methods: {
            dologin() {
                this.$store
                    .dispatch('login', {
                        username: this.username,
                        password: this.password
                    })
                    .then(() => {
                        if(this.$store.state.user === null){
                            this.errorMsg = 'Utilisateur ou mot de passe incorrect !'
                            this.snackbar = true
                        }else {
                            this.$router.push({name: 'ListeRdv'})
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
    }
</script>
